module.exports = __webpack_public_path__ + "img/C08TechVanisWisdomRM_ua.c49f173a.webp";